<template>
  <step :active="activeStep"></step>
  
  <!-- 主内容区 -->
  <div class="main-content">
    <!-- 电子票卡片 -->
    <div class="ticket-card">
      <!-- 票卡顶部 - 展会名称 -->
      <div class="ticket-header">
        <div class="usage-header" v-html="gconfig.SuccessPage"></div>
      </div>
      
      <!-- 撕票线效果 -->
      <div class="tear-line">
        <div class="tear-notch tear-notch--left"></div>
        <div class="tear-notch tear-notch--right"></div>
      </div>
      
      <!-- 二维码区域 - 电子票模式：滑动显示多个二维码 -->
      <div class="ticket-body ticket-body--eticket" v-if="gconfig.IsHaveETicket === 'True' && tktBuyList.length > 0">
        <van-swipe class="qr-swipe" :show-indicators="tktBuyList.length > 1" indicator-color="var(--color-primary, #E60044)">
          <van-swipe-item v-for="(ticket, index) in tktBuyList" :key="index">
            <div class="eticket-item">
              <div class="eticket-left">
                <div class="qr-container">
                  <qrcode-vue :value="ticket.ticket_CardCode" :size="140"></qrcode-vue>
                </div>
              </div>
              <div class="eticket-right">
                <div class="ticket-badge">{{ ticket.ticket_Name || ticket.ticket_Ename }}</div>
                <div class="user-info-compact">
                  <span class="user-name-compact">{{ visitorObj.VisitorName }}</span>
                  <span class="user-company-compact" v-if="visitorObj.VisitorComName">{{ visitorObj.VisitorComName }}</span>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      
      <!-- 二维码区域 - 普通模式：显示访客二维码 -->
      <div class="ticket-body" v-else>
        <div class="qr-container">
          <qrcode-vue :value="visitorObj.VistorVisCard" :size="150"></qrcode-vue>
        </div>
        <!-- 用户信息 -->
        <div class="qr-user-info">
          <div class="user-name">{{ visitorObj.VisitorName }}</div>
          <div class="user-company" v-if="visitorObj.VistorRank">{{ visitorObj.VistorRank }}</div>
          <div class="user-company" v-if="visitorObj.VisitorComName">{{ visitorObj.VisitorComName }}</div>
        </div>
      </div>
      
      <!-- 底部半圆缺口装饰 -->
       <div class="ticket-footer">
        <div class="footer-notch footer-notch--left"></div>
        <div class="footer-notch footer-notch--right"></div>
      </div> 
    </div>

    
    <!-- 活动信息 -->
    <div class="info-section">
      <div class="info-row" v-if="gconfig.ExhTime">
        <span class="info-label">活动时间：</span>
        <span class="info-value">{{ gconfig.ExhTime }}</span>
      </div>
      <div class="info-row" v-if="gconfig.ExhAddress">
        <span class="info-label">活动地点：</span>
        <span class="info-value">{{ gconfig.ExhAddress }}</span>
      </div>
    </div>
    
    <!-- 分享区域 - 仅当没有电子票功能时显示 -->
    <div class="share-section" v-if="gconfig.IsHaveETicket !== 'True'">
      <div class="share-title">邀请分享</div>
      <div class="share-buttons">
        <div class="share-btn" @click="shareToFriend">
          <van-icon name="chat-o" size="24" />
          <span>分享邀请</span>
        </div>
        <div class="share-btn" @click="generatePoster" style="display: none;">
          <van-icon name="photo-o" size="24" />
          <span>专属邀请函</span>
        </div>
        <div class="share-btn" @click="goMyInvite">
          <van-icon name="photo-o" size="24" />
          <span>我的邀请</span>
        </div>
      </div>
    </div>
    
    <!-- 使用说明区域 -->
    <div class="usage-section">
      <div class="usage-note" v-html="gconfig.SuccessPageBottomText"></div>
    </div>
  </div>

  <!-- 审核弹窗 -->
  <div class="shMask" v-show="showSh">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div class="shConBox">
      <div class="shDiv">
        <img :src="shIcon" alt="" />
        <h3>审核中</h3>
        <div v-html="shContent" class="shTxt"></div>
      </div>
    </div>
  </div>
  
  <!-- 补充身份证 -->
  <div class="shMask" v-show="showVerCard">
    <img :src="gconfig.Banner" style="width: 100%" alt="" />
    <div>
      <p style="padding: 15vw 0 8vw; font-size: 1.2em; font-weight: 600">
        请您补充证件号码，完成实名认证！
      </p>
      <van-form @failed="onFailed" @submit="onSubmit">
        <van-cell-group>
          <van-field
            v-model="formMg.Name"
            Name="Name"
            label="姓名"
            :rules="rulesAll.Name"
            class="requiredItem"
          />
          <van-field
            class="requiredItem"
            v-model="formMg.IDCardNo"
            Name="IDCardNo"
            label="身份证号"
            :rules="rulesAll.IDCardNo"
          />
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            round
            style="width: 45%; border-radius: 44px"
            :color="mainColor"
            type="primary"
            native-type="submit"
            :disabled="btnLoading"
            :loading="btnLoading"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
  <!-- 微信分享提示 -->
  <div class="shareModel" v-if="showShareModel">
    <img :src="wxshare" @click="closeShareModel" />
  </div>
  <!-- 小程序浮动按钮 -->
  <div class="floating-btn" @click="openMiniProgram" v-if="ismini">
    <img src="@/assets/mini-program-icon.jpeg" alt="回到首页" />
  </div>
</template>
<script setup>
import shIcon from '@/assets/shIcon.png'
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import step from '@/components/step.vue'
import wx from '@/utils/wx.js'
import wxJDK from 'weixin-js-sdk'
import { decryptionECB } from '@/utils/utils.js'
import { validatorName } from '@/utils/validators.js'
import { regCId } from '@/utils/regs.js'
import wxshare from '@/assets/wxshare.png'
const store = useStore()
const router = useRouter()
const ExhCode = computed(() => store.state.ExhCode)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const showShareModel = ref(false)

const mainColor = computed(() => store.state.mainColor)
// console.log(gconfig.value, '222222222')
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
const visitorObj = ref({})

// 计算当前步骤（成功页是最后一步）
const activeStep = computed(() => {
  let step = 1 // 基本信息
  if (gconfig.value.IsHaveQuestion === 'True') {
    step++ // 问卷调查
  }
  if (gconfig.value.IsHaveETicket === 'True') {
    step++ // 购买门票
  }
  return step
})
// 是否显示审核
const showSh = ref(false)
// 审核显示内容
const shContent = ref('')
// 是否小程序
const ismini = ref(false)
// 购票列表（用于电子票二维码显示）
const tktBuyList = ref([])
const getMsg = async () => {
  const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  visitorObj.value = jmRes
   console.log(visitorObj.value)
  // 判断是否显示审核
  if (gconfig.value.IsNeedCheck === 'True') {
    if (
      visitorObj.value.VisitorCheckSysstate === null ||
      visitorObj.value.VisitorCheckSysstate === '' ||
      visitorObj.value.VisitorCheckSysstate === '未通过'
    ) {
      showSh.value = true
      if (
        visitorObj.value.VisitorCheckSysstate === null ||
        visitorObj.value.VisitorCheckSysstate === ''
      ) {
        shContent.value = gconfig.value.WaitCheckContent
      } else {
        shContent.value = gconfig.value.CheckFailContent
      }
      return false
    } else {
      showSh.value = false
    }
  }
  if (gconfig.value.IsNeedIDCard === 'True') {
    // 是否需要补实名
    if (!visitorObj.value.VisitorIDCard) {
      // 如果没有身份证
      showVerCard.value = true
      formMg.value.Name = visitorObj.value.VisitorName
      return false
    }
    showVerCard.value = false
  }
  showSh.value = false
}
// 进入页面后强制滚到顶部，抽出为顶层函数供 onMounted / watch 复用
const scrollToTop = () => {
  const main = document.querySelector('.home > .main')
  if (main) main.scrollTop = 0
  window.scrollTo(0, 0)
  if (document.documentElement) document.documentElement.scrollTop = 0
  if (document.body) document.body.scrollTop = 0
}
// 持续锁定页面顶部，直到用户主动操作或超时。
// 针对从 questions 进入时 scroll anchoring + 异步数据加载反复把页面钉到底部的场景。
const setupScrollLock = (duration = 1500) => {
  const main = document.querySelector('.home > .main')
  let active = true
  const onScroll = () => {
    if (!active) return
    scrollToTop()
  }
  const release = () => {
    if (!active) return
    active = false
    if (main) main.removeEventListener('scroll', onScroll)
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('touchstart', release, true)
    window.removeEventListener('wheel', release, true)
    window.removeEventListener('keydown', release, true)
  }
  if (main) main.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('scroll', onScroll, { passive: true })
  // 用户主动操作立即解锁，不干扰后续浏览
  window.addEventListener('touchstart', release, true)
  window.addEventListener('wheel', release, true)
  window.addEventListener('keydown', release, true)
  setTimeout(release, duration)
}
// 数据回填后（visitorObj / tktBuyList 变化）再回一次顶，避免二维码 / van-swipe / v-html
// 在 API 返回后才撑开导致 scroll anchoring 把页面钉在中间或底部。
watch(
  () => [visitorObj.value && visitorObj.value.VistorVisCard, tktBuyList.value.length],
  () => {
    scrollToTop()
    nextTick(scrollToTop)
    setTimeout(scrollToTop, 100)
  }
)
onMounted(() => {
  // 进入页面后强制滚到顶部（兼容 scrollBehavior 时序被后续渲染 / 异步数据加载征走的情况）
  scrollToTop()
  // 在 1.5s 内对任何非主动滚动都拉回顶部（questions → success 场景必需）
  setupScrollLock(1500)
  // 多补几次，覆盖 v-html / van-swipe / 二维码后加载可能造成的跳动
  setTimeout(scrollToTop, 0)
  setTimeout(scrollToTop, 100)
  setTimeout(scrollToTop, 300)
  setTimeout(scrollToTop, 600)
  setTimeout(scrollToTop, 1000)

  getMsg()
  // 判断是否需要检查电子票
  if (gconfig.value.IsHaveETicket === 'True') {
    checkETicketStatus()
  }
  if (isWeX.value) {
    wx.getWXSign()
  }
  if (/miniprogram/i.test(navigator.userAgent)) {
    ismini.value = true
  }
})

// 检查电子票状态
const checkETicketStatus = async () => {
  try {
    const res = await api.getTicketListApi({
      ExhCode: ExhCode.value,
      VisitorID: VisitorID.value,
      type: '1'
    })
    if (res.code === 200) {
      // 保存购票列表
      tktBuyList.value = res.data.tickets || []
      // 如果没有购票记录，跳转到电子票选择页面
      if (tktBuyList.value.length === 0) {
        router.push({ path: '/eticket' })
      }
    }
  } catch (error) {
    console.error('获取购票列表失败', error)
  }
}
const showVerCard = ref(false)
const formMg = ref({
  Name: '',
  IDCardNo: ''
})
// 校验证件号
const validatorIDCardNo = (val) => {
  return regCId(val)
}
const rulesAll = ref({
  Name: [
    { required: true, validator: validatorName, message: '请输入正确的姓名' }
  ],
  IDCardNo: [{ validator: validatorIDCardNo, message: '请输入正确的身份证号' }]
})
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
const onSubmit = async (values) => {
  const res = await api.UpdateIDcardApi({
    VisitorID: VisitorID.value,
    Name: formMg.value.Name,
    IDCardNo: formMg.value.IDCardNo,
    exhcode: ExhCode.value
  })
  if (res.code === 200) {
    getMsg()
  }
}
const openMiniProgram = () => {
  wxJDK.miniProgram.reLaunch({
    url: '/pages/index/index',
    fail: function (res) {
      console.log('fail', res)
    },
    success: function (res) {
      console.log('success', res)
    }
  })
}

// 分享给好友
const shareToFriend = () => {
  showShareModel.value=true
  // 微信分享逻辑
}

// 生成分享大图
const generatePoster = () => {
  // 生成海报逻辑
}

// 跳转到我的邀请页面
const goMyInvite = () => {
  router.push('/myinvite')
}
const closeShareModel = () => {
  showShareModel.value = false
}
</script>
<style lang="less" scoped>
@import '../../assets/login.less';

// 主内容区
.main-content {
  padding: 16px;
  background: #fff;
}

// 电子票卡片
.ticket-card {
  position: relative;
  background: #fff;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.15),
    0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 0 8px 24px;
}

// 票卡顶部 - 展会名称
.ticket-header {
  padding: 15px 20px 15px;
  text-align: center;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  border-radius: 16px 16px 0 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--color-primary, #E60044) 0%, #ff6b6b 100%);
  }
  
  .exhibition-name {
    color: var(--text-primary, #1a1a1a);
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    line-height: 1.4;
    letter-spacing: 0.5px;
  }
}

// 撕票线效果
.tear-line {
  position: relative;
  height: 0;
  border-top: 2px dashed #E0E0E0;
  background: #fff;
  
  .tear-notch--left {
    position: absolute;
    top: 50%;
    left: -12px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background: var(--bg-main, #F5F7FA);
    border-radius: 50%;
    box-shadow: inset -2px 0 4px rgba(0, 0, 0, 0.08);
  }
  
  .tear-notch--right {
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background: var(--bg-main, #F5F7FA);
    border-radius: 50%;
    box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.08);
  }
}

// 票卡主体 - 二维码
.ticket-body {
  padding: 14px 16px 12px;
  text-align: center;
  background: #fff;
  
  &--eticket {
    padding: 10px 16px 20px;
  }
}

// 电子票滑动区域
.qr-swipe {
  .van-swipe-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .van-swipe__indicators {
    bottom: -20px;

    .van-swipe__indicator {
      width: 6px;
      height: 6px;
      margin: 0 3px;
    }
  }
}

// 电子票横向布局
.eticket-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #fff 0%, #fafafa 100%);
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 100%;
}

.eticket-left {
  flex-shrink: 0;
}

.eticket-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qr-container {
  display: inline-block;
  padding: 6px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ticket-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-primary, #E60044);
  background: linear-gradient(135deg, rgba(230, 0, 68, 0.06) 0%, rgba(255, 107, 107, 0.06) 100%);
  padding: 3px 10px;
  border-radius: 10px;
  width: fit-content;
  letter-spacing: 0.5px;
  border: 1px solid rgba(230, 0, 68, 0.1);
}

.user-info-compact {
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  .user-name-compact {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
    text-align: left;
  }
  
  .user-company-compact {
    font-size: 13px;
    color: #666;
    text-align: left;
  }
}

// 用户信息
.qr-user-info {
  margin-top: 12px;
  text-align: center;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, transparent, var(--color-primary, #E60044), transparent);
    border-radius: 2px;
  }
  
  .user-name {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 4px;
    letter-spacing: 1px;
  }
  
  .user-company {
    font-size: 14px;
    color: #666;
    font-weight: 400;
  }
}

.qr-hint {
  margin-top: 12px;
  font-size: 13px;
  color: #999;
}

// 底部半圆缺口装饰
.ticket-footer {
  position: relative;
 // height: 20px;
  background: #fff;
  border-radius: 0 0 16px 16px;
  
  .footer-notch--left {
    position: absolute;
    bottom: 0;
    left: -12px;
    width: 24px;
    height: 24px;
    background: var(--bg-main, #F5F7FA);
    border-radius: 50%;
    box-shadow: inset -2px 0 4px rgba(0, 0, 0, 0.08);
  }
  
  .footer-notch--right {
    position: absolute;
    bottom: 0;
    right: -12px;
    width: 24px;
    height: 24px;
    background: var(--bg-main, #F5F7FA);
    border-radius: 50%;
    box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.08);
  }
}

// 活动信息
.info-section {
  //padding: 12px 0;
  border-bottom: 1px solid #F0F0F0;
}

.info-row {
  display: flex;
  padding: 8px 0;
  font-size: 14px;
  
  .info-label {
    color: #666;
    flex-shrink: 0;
  }
  
  .info-value {
    color: #333;
  }
}
.shareModel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  z-index: 9999;
  img {
    width: 66%;
    margin-top: 20vw;
  }
}

// 分享区域
.share-section {
  padding: 20px 0;
  
  .share-title {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  }
  
  .share-buttons {
    display: flex;
    justify-content: center;
    gap: 24px;
  }
  
  .share-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 24px;
    background: #F8F9FA;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:active {
      transform: scale(0.96);
      background: #F0F1F2;
    }
    
    .van-icon {
      color: var(--color-primary, #E60044);
      margin-bottom: 8px;
    }
    
    span {
      font-size: 13px;
      color: #333;
    }
  }
}

// 使用说明区域
.usage-section {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  
  .usage-header {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    
    :deep(p) {
      margin: 0;
    }
  }
}

.usage-note {
  padding: 12px 16px;
  font-size: 12px;
  line-height: 1.8;
  color: #666;
  
  :deep(p) {
    margin: 4px 0;
  }
}

// 审核弹窗
.shMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 2;
}

.shConBox {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: var(--bg-main, #F5F7FA);
  
  .shDiv {
    position: absolute;
    top: 35%;
    left: 50%;
    margin-top: -50%;
    margin-left: -40%;
    width: 80%;
    background: var(--bg-card, #fff);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding: 8vh 0 15vh;
    
    h3 {
      text-align: center;
      color: var(--color-primary, #E60044);
      font-size: 18px;
      font-weight: 600;
      padding: 2vh 0;
    }
    
    img {
      width: 30%;
    }
    
    .shTxt {
      text-align: left !important;
      font-size: 14px;
      line-height: 28px;
      color: var(--text-primary, #333);
      padding: 0 5vw;
    }
  }
}

// 小程序浮动按钮
.floating-btn {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 56px;
  height: 56px;
  background: var(--bg-card, #fff);
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: transform 0.3s ease;
  
  &:active {
    transform: scale(0.95);
  }

  img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
}
</style>
